import { format } from "date-fns";

export const displayFormattedDate = (
  date?: string | Date,
  offsetTimeZone = true,
  formatString = "MM/dd/yyyy hh:mm a"
): string | undefined => {
  if (!date) return undefined;
  let unformattedDate = date.constructor === Date ? date : new Date(date);
  if (offsetTimeZone) {
    unformattedDate = new Date(
      unformattedDate.getTime() - unformattedDate.getTimezoneOffset() * 60000
    );
  }
  return format(unformattedDate, formatString);
};
